import { css } from 'linaria';

export const stockInStoresTitleContainer = css`
  display: flex;
  justify-content: space-between;
  margin: var(--space-100) 0 var(--space-75);
  padding-top: var(--space-150);
  text-decoration: none;
`;

export const stockInStoresTitleText = css`
  margin: var(--space-25) 0;
`;

export const showMoreStocks = css`
  cursor: pointer;
`;

export const pickupOpt = css`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--space-150);
  padding: var(--space-50) 0;
`;

export const pickupOptTextContent = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--space-300) !important;
  justify-content: space-between;
`;

export const pickupOptIconCntr = css`
  width: var(--space-300);
  height: var(--space-300);
`;

export const stockInStoresModalCloseButton = css`
  width: 100%;
`;

export const modalShopItem = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  padding: var(--space-200) 0;
  border-bottom: solid 1px var(--control-minor);
`;

export const modalShopsList = css`
  padding: 0 var(--space-400);
`;

export const modalShopItemLabel = css`
  display: flex;
  gap: var(--space-50);
`;

export const modalShopItemStock = css`
  margin-top: var(--space-50);
`;
